// extracted by mini-css-extract-plugin
module.exports = {"cta":"cta_cta__cd7rT","dream":"cta_dream__RVraD","machine":"cta_machine__Bh_oh","message":"cta_message__TnuxT","submessage":"cta_submessage__M3GpW","image":"cta_image__e_lyT"};